import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../../../globals';
import { DishServices } from '../../../../../dish/services';
import { IngredientsServices } from '../../../../../ingredients/services';
import { ProductsServices } from '../../../../../products/services';
import { ConfigurationServices } from '../../../../services';

@Component({
    selector: 'page-configuration-variation-add-elements',
    templateUrl: 'configuration-variation-add-elements.html'
})

export class ConfigurationVariationAddElementsPage {

    variation: any;
    selected_collapse: boolean = false;

    constructor(public navCtrl: NavController,
        public globals: Globals,
        public dishServices: DishServices,
        public ingredientsServices: IngredientsServices,
        public productsServices: ProductsServices,
        public loadingCtrl: LoadingController,
        public navParams: NavParams,
        public translate: TranslateService,
        public configurationServices: ConfigurationServices,) {

        this.variation = this.navParams.get('variation');
    }

    ionViewWillEnter() {
        this.configurationServices.getPagesDishesProducts(0);
    }

    save() {
        this.navCtrl.pop();
    }
    searchDishesProductsNode(value) {
        this.configurationServices.searchDishesProductsNode(value);
    }
    collapse() {
        this.selected_collapse = !this.selected_collapse;
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variation-add-elements/configuration-variation-add-elements.ts